'use strict';

(function () {
    angular.module('stores').constant('TIMEZONES', [{ name: 'Eastern', tzName: 'US/Eastern' }, { name: 'Central', tzName: 'US/Central' }, { name: 'Mountain', tzName: 'US/Mountain' }, { name: 'Pacific', tzName: 'US/Pacific' }, { name: 'Alaska', tzName: 'US/Alaska' }, { name: 'Arizona', tzName: 'US/Arizona' }, { name: 'Hawaii', tzName: 'US/Hawaii' }]);
})();